module.exports = __webpack_public_path__ + "img/recycling-refresh.4ff5bc25.svg";